export const actions = {
    START_FETCH_DATA: "START_FETCH_DATA",
    STORE_DATA: "STORE_DATA",

    CLEAN_DATA: "CLEAN_DATA",
};

export const initialState = {};

export default (state = initialState, { type, data, key }) => {
    switch (type) {
        case actions.STORE_DATA: {
            return Object.assign({}, state, { [key]: data });
        }
        case actions.CLEAN_DATA: {
            return Object.fromEntries(Object.entries(state).filter((entry) => entry[0] !== key));
        }
        default:
            return state;
    }
};
